import { afterAttack, afterEvent, defineGameCard, heatsUp } from '../authoring/index.js';
const LOST_ATTACK_KEY = 'impulseAttackLost';
export const ImpulseFighterCard = defineGameCard({
    id: 'impulse_fighter',
    gameplay: {
        type: 'UNIT', cost: 2,
        baseStats: { attack: 3, health: 2 }, keywords: ['RUSH'],
    },
    presentation: {
        name: 'Импульсный боец',
        description: 'Натиск. Греется. После атаки теряет 1 атаку. При полном охлаждении восстанавливает всю атаку, потерянную этой способностью.',
        glyph: {
            colors: ['#10213A', '#3B4A59', '#69756B', '#334855', '#294C55'],
            rows: [
                '....................',
                '....................',
                '..........1111......',
                '.........123331.....',
                '........14223331....',
                '.....11114413331....',
                '...1122351411331.11.',
                '..1221433114441.122.',
                '..121..14331133.144.',
                '..1221.143333551411.',
                '...11..14331114441..',
                '......114411..111...',
                '.....12224121.......',
                '....1144414421......',
                '...143311.1141......',
                '..144331..1441......',
                '..14111...111.......',
                '..21......144.......',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterAttack((ctx) => {
            const self = ctx.self;
            if (self === undefined || ctx.q.stats(self).attack <= 0)
                return;
            const lost = Number(self.vars[LOST_ATTACK_KEY] ?? 0);
            ctx.ops.modifyStat(self.id, 'attack', -1);
            ctx.ops.setVar(LOST_ATTACK_KEY, lost + 1);
        }),
        heatsUp(),
        afterEvent({
            event: 'HeatChanged',
            when: (ctx, event) => ctx.self !== undefined
                && event.instanceId === ctx.self.id
                && event.reason === 'cooled'
                && event.previous > 0
                && event.current === 0
                && Number(ctx.self.vars[LOST_ATTACK_KEY] ?? 0) > 0,
            run: (ctx) => {
                const self = ctx.self;
                if (self === undefined)
                    return;
                const lost = Number(self.vars[LOST_ATTACK_KEY] ?? 0);
                ctx.ops.modifyStat(self.id, 'attack', lost);
                ctx.ops.setVar(LOST_ATTACK_KEY, 0);
            },
        }),
    ],
    ui: { mechanics: ['rush', 'heats_up', 'heat'] },
});
//# sourceMappingURL=impulse-fighter.js.map